export {
  fetchConfig
} from './config';
export {
  queryCoverage,
  showCoverage
} from './coverage';


// WEBPACK FOOTER //
// ./src/services/api/index.js